import { css } from 'linaria';

export const SEASON_START_PLOT_PATH = '/promo/pora-pora-uchastok/';

export const SEASON_START_PLOT_ELEMENT_BLOCK = 'landingStartSezonaUchastok';

export const SEASON_START_PLOT_CDN_PATH = 'https://cdn.lemanapro.ru/lmru/image/upload/f_auto,c_pad,b_auto,d_photoiscoming.png/fudzi/elbrus/images/landings/season-start-plot';

export const SEASON_START_PLOT_LANDING_NAME = 'season-start-plot';

export const SEASON_START_PLOT_SOLUTIONS = [
  {
    link: {
      href: '/promo/pora-pora-stroitelstvo/',
      title: 'Поможем построить',
    },
    img: {
      alt: 'Баннер Поможем построить',
      srcD: `${SEASON_START_PLOT_CDN_PATH}/banners/construction-banner-ld.jpg/construction-banner-ld-01.jpg`,
      srcT: `${SEASON_START_PLOT_CDN_PATH}/banners/construction-banner-t.jpg/construction-banner-t-02.jpg`,
      src: `${SEASON_START_PLOT_CDN_PATH}/banners/construction-banner-m.jpg/construction-banner-m-02.jpg`,
    }
  },
  {
    link: {
      href: '/promo/pora-pora-dom/',
      title: 'Обустроим дом',
    },
    img: {
      alt: 'Баннер Обустроим дом',
      srcD: `${SEASON_START_PLOT_CDN_PATH}/banners/house-banner-ld.jpg/house-banner-ld.jpg`,
      srcT: `${SEASON_START_PLOT_CDN_PATH}/banners/house-banner-t.jpg/house-banner-t.jpg`,
      src: `${SEASON_START_PLOT_CDN_PATH}/banners/house-banner-m.jpg/house-banner-m.jpg`,
    }
  }
];

export const SEASON_START_PLOT_SOLUTIONS_CATEGORIES = [
  {
    discountBableSrc: `${SEASON_START_PLOT_CDN_PATH}/categories/discount-bable.png/discount-bable.png`,
    title: 'Отдохните\nна природе',
    img: {
      className: css`
        @media (--only-largeDesktop) {
          height: 775px;
        }

        @media (--only-desktop) {
          height: 714px;
        }

        @media (--only-tablet) {
          height: 660px;
        }

        @media (--only-mobile) {
          height: 586px;
        }
      `,
      srcLd: `${SEASON_START_PLOT_CDN_PATH}/categories/nature-bg-ld.jpg/nature-bg-ld.jpg`,
      srcD: `${SEASON_START_PLOT_CDN_PATH}/categories/nature-bg-d.jpg/nature-bg-d.jpg`,
      srcT: `${SEASON_START_PLOT_CDN_PATH}/categories/nature-bg-t.jpg/nature-bg-t.jpg`,
      src: `${SEASON_START_PLOT_CDN_PATH}/categories/nature-bg-m.jpg/nature-bg-m-01.jpg`,
    },
    itemList: [
      {
        href: '/offer/pora-pora-za-grilyami-i-mangalami-po-supercenam',
        img: {
          alt: 'Изображение гриля',
          src: `${SEASON_START_PLOT_CDN_PATH}/categories/grill.jpg/grill.jpg`,
        },
        title: 'Грили и мангалы',
      },
      {
        cashback: 10,
        href: '/offer/pora-pora-za-sadovoy-mebelyu-po-supercenam',
        img: {
          alt: 'Изображение садовой мебели',
          src: `${SEASON_START_PLOT_CDN_PATH}/categories/garden-furniture.jpg/garden-furniture.jpg`,
        },
        title: 'Садовая мебель со сборкой',
      },
    ]
  },
  {
    discountBableSrc: `${SEASON_START_PLOT_CDN_PATH}/categories/discount-bable.png/discount-bable.png`,
    title: 'Насладитесь\nкрасивым участком',
    img: {
      className: css`
        @media (--only-largeDesktop) {
          height: 775px;
        }

        @media (--only-desktop) {
          height: 714px;
        }

        @media (--only-tablet) {
          height: 786px;
        }

        @media (--only-mobile) {
          height: 674px;
        }
      `,
      srcLd: `${SEASON_START_PLOT_CDN_PATH}/categories/plot-bg-ld.jpg/plot-bg-ld.jpg`,
      srcD: `${SEASON_START_PLOT_CDN_PATH}/categories/plot-bg-d.jpg/plot-bg-d.jpg`,
      srcT: `${SEASON_START_PLOT_CDN_PATH}/categories/plot-bg-t.jpg/plot-bg-t.jpg`,
      src: `${SEASON_START_PLOT_CDN_PATH}/categories/plot-bg-m.jpg/plot-bg-m.jpg`,
    },
    itemList: [
      {
        href: '/offer/pora-pora-za-ulichnym-osveshcheniem-po-supercenam/',
        img: {
          alt: 'Изображение уличного фанаря',
          src: `${SEASON_START_PLOT_CDN_PATH}/categories/street-lighting.jpg/street-lighting.jpg`,
        },
        title: 'Уличное освещение',
      },
      {
        href: '/offer/pora-pora-za-tovarami-dlya-uhoda-za-sadom-i-ogorodom-po-supercenam/',
        img: {
          alt: 'Изображение садового растения',
          src: `${SEASON_START_PLOT_CDN_PATH}/categories/garden-maintenance.jpg/garden-maintenance.jpg`,
        },
        title: 'Уход за садом',
      },
      {
        href: '/offer/pora-pora-za-sadovimi-dorozkami/',
        img: {
          alt: 'Изображение садовоой дорожки',
          src: `${SEASON_START_PLOT_CDN_PATH}/categories/garden-paths.jpg/garden-paths.jpg`,
        },
        title: 'Садовые дорожки',
      },
      {
        href: '/offer/pora-pora-za-tehnikoy-dlya-sada-po-supercenam/',
        img: {
          alt: 'Изображение газонокосилки',
          src: `${SEASON_START_PLOT_CDN_PATH}/categories/garden-equipment.jpg/garden-equipment.jpg`,
        },
        title: 'Техника для сада',
      },
      {
        href: '/uslugi/gotovye-resheniya-pod-klyuch/zabory-na-zakaz/',
        img: {
          alt: 'Изображение забора из штакетника',
          src: `${SEASON_START_PLOT_CDN_PATH}/categories/fences.jpg/fences.jpg`,
        },
        title: 'Заборы на заказ',
      },
    ]
  },
];
